import { cycleCountPlanIdFormat } from "@redotech/redo-inventory-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

/**
 * A plan row nothing is stocked against has no level to count, so attesting it
 * empty is what finishes it. Takes a list so a bulk sweep needs no new RPC.
 */
export const setCycleCountPlansEmpty = unaryRpc({
  name: "setCycleCountPlansEmpty" as const,
  input: z.object({
    planIds: z.array(cycleCountPlanIdFormat.schema).min(1).max(500),
    /** False reopens the row, the way clearing a count reopens a counted one. */
    empty: z.boolean(),
  }),
  output: z.object({}),
});
